import * as utils from '../../../shared/utils';

/**
 * Updating fields(meta, etc.) for many assets
 * @param {Array} items - current state assets,
 * @param {Array} assets - assets with new fields(meta, etc.),
 * @returns {Array}
 */
export default function setFieldsForManyAssets(items = [], assets = []) {
  const assetsLUT = assets.reduce((acc, asset) => {
    acc[asset._id] = asset;
    return acc;
  }, {});

  return items.map((item) => {
    const asset = assetsLUT[item._id];
    if (!asset) return item;

    const newItem = { ...item };

    asset.fields.forEach((key, index) => {
      if (utils.isObject(asset.values[index]) && utils.isObject(newItem[key])) {
        /** if field is object */
        newItem[key] = { ...newItem[key], ...asset.values[index] };
      } else {
        /** just add new value or replace old value */
        newItem[key] = asset.values[index];
      }
    });

    return newItem;
  });
}
